module.exports = __webpack_public_path__ + "img/haibao2@2x.a41bbe8c.png";